import { onboarding } from '@services';

export interface IGetIdentificationRequestsCount {
  open: number;
  closed: number;
  information_needed: number;
  confirm_product: number;
  resolved: number;
}

const getIdentificationRequestsCount =
  async (): Promise<IGetIdentificationRequestsCount> => {
    const { data } = await onboarding.get<IGetIdentificationRequestsCount>(
      `/api/v1/file/irequest/count`,
    );

    return {
      ...data,
      open: data.open + data.confirm_product + data.information_needed,
    };
  };

export { getIdentificationRequestsCount };
